import React, { Component } from 'react';
import classnames from 'classnames';
import TextareaAutosize from 'react-autosize-textarea';

export default class Textarea extends Component {

  render() {
    const { className, ...props } = this.props;
    const classes = ['autogrow', className];

    return (
      <div className="textarea-container">
        <TextareaAutosize
          className={classnames(classes)}
          rows={1}
          {...props}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/Textarea.js